var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCamera(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "currentColor",
    strokeWidth: 3.5,
    fillOpacity: 0.4,
    fill: "#000",
    cx: 25,
    cy: 25,
    r: 23.25
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35.868 26.498a.773.773 0 0 0-1.046.25.732.732 0 0 0 .257 1.02c.901.532 1.398 1.11 1.398 1.63 0 .549-.548 1.157-1.543 1.712-1.152.642-2.796 1.16-4.754 1.498a.745.745 0 0 0-.618.86.757.757 0 0 0 .883.603c4.73-.816 7.555-2.563 7.555-4.673 0-1.358-1.16-2.326-2.132-2.9zm-10.411 6.68-2.031-1.485a.775.775 0 0 0-1.067.148.73.73 0 0 0 .153 1.04l.086.063c-2.26-.164-4.333-.558-5.99-1.15-1.931-.691-3.085-1.587-3.085-2.396 0-.52.497-1.098 1.398-1.63a.732.732 0 0 0 .257-1.02.773.773 0 0 0-1.046-.25C13.16 27.07 12 28.04 12 29.398c0 1.015.666 1.791 1.225 2.263.686.58 1.648 1.094 2.859 1.527 1.864.666 4.198 1.1 6.724 1.259l-.296.216a.73.73 0 0 0-.153 1.04.772.772 0 0 0 1.066.149l2.032-1.486a.737.737 0 0 0 .305-.594.737.737 0 0 0-.305-.594zM25 25.626c.93 0 1.687-.738 1.687-1.645s-.756-1.645-1.687-1.645c-.93 0-1.687.738-1.687 1.645s.756 1.645 1.687 1.645z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.385 29.52h11.23c1.409 0 2.554-1.118 2.554-2.491v-6.097c0-1.372-1.145-2.49-2.554-2.49H20.67v-1.767a.752.752 0 0 0-.762-.742.752.752 0 0 0-.762.742v1.778c-1.297.117-2.316 1.185-2.316 2.48v6.096c0 1.373 1.145 2.49 2.554 2.49zM25 20.85c1.77 0 3.21 1.404 3.21 3.13 0 1.727-1.44 3.132-3.21 3.132s-3.21-1.405-3.21-3.131c0-1.727 1.44-3.13 3.21-3.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.77 16.02c0-.563-.47-1.02-1.047-1.02h-3.446c-.578 0-1.046.457-1.046 1.02v.937h5.538v-.937z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.bcc8ee54d47f5b5637439adcaeaa53bd.svg";
export { ForwardRef as ReactComponent };